// extracted by mini-css-extract-plugin
module.exports = {"errorMessageBG":"DiffViewer_errorMessageBG__zKBu4","errorMessageTxt":"DiffViewer_errorMessageTxt__DzzCD"};